import { useCallback } from "react";
import { useService } from "./useService";

const language = {
  en: require("../../language/en.json"),
  hi: require("../../language/hi.json"),
};

export const useLocale = () => {
  const { getActiveLanguage, isEmpty } = useService("Misc");
  const activeLanguage = getActiveLanguage();
  const parseLanguage = useCallback(
    (lng: any, key: string): string => {
      if (!lng) return key;
      if (!isEmpty(lng[key])) {
        return lng[key];
      } else {
        const dotIndex = key.indexOf(".");
        if (dotIndex === -1) return key;
        const trnKey = key.substring(0, dotIndex);
        return parseLanguage(lng[trnKey], key.replace(trnKey + ".", ""));
      }
    },
    [isEmpty]
  );
  const translate = useCallback(
    (key: string): string => {
      return parseLanguage(language[activeLanguage], key);
    },
    [parseLanguage, activeLanguage]
  );
  return {
    t: translate,
  };
};
